const SELECT = {
    'class': 'table-wrap',
};

export const tableWrapper = {
    init: function(selector) {
        const element = document.querySelector(selector);
        if (element !== null) {
            const tables = element.querySelectorAll('table');
            tables.forEach((element) => {
                if (element.closest(SELECT.class) !== null) return;

                const newTableHtml = `<div class="${SELECT.class}">${element.outerHTML}</div>`;
                element.insertAdjacentHTML('afterend', newTableHtml);
                element.remove();
            });
        }
    },
};
